import moment from 'moment';

export default function localDate(timestampString) {
  return moment.utc(timestampString).format('MM/DD/YY');
}



// WEBPACK FOOTER //
// ./shared/lib/localDate.js